<template>
	<div>
		<div style="display: flex;align-items: center;justify-content: space-between;">
			<a-breadcrumb style="margin: 16px 0">
				<a-breadcrumb-item>主页</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectFirstMenu}}</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectSecondMenu}}</a-breadcrumb-item>
			</a-breadcrumb>
			<div>
				<a-button icon="sync" @click="apiOperationLogQueryList">刷新</a-button>
			</div>
		</div>
		
		<a-collapse expandIconPosition="right" activeKey="1">
			<a-collapse-panel key="1" header="操作日志查询">
				<div class="qinang-search-row">
                    <div class="qinang-search-col-3">
						<div class="qinang-search-col-title" style="width: 120px;">访问用户：</div>
						<a-input v-model="query.staffId" style="width: 100%;" placeholder="请输入访问用户ID" />
					</div>
                    <div class="qinang-search-col-3">
						<div class="qinang-search-col-title" style="width: 120px;">访问模块：</div>
						<a-input v-model="query.module" style="width: 100%;" placeholder="请输入访问模块" />
					</div>
					<div class="qinang-search-col-3">
						<div class="qinang-search-col-title" style="width: 120px;">访问IP：</div>
						<a-input v-model="query.ipAddress" style="width: 100%;" placeholder="请输入访问IP地址" />
					</div>
				</div>
                <div class="qinang-search-row" style="margin-top: 10px;">
                    <div class="qinang-search-col-3">
						<div class="qinang-search-col-title" style="width: 120px;">访问路径：</div>
						<a-input v-model="query.requestUrl" style="width: 100%;" placeholder="请输入访问路径" />
					</div>
					<div class="qinang-search-col-3">
						<div class="qinang-search-col-title" style="width: 120px;">返回状态：</div>
						<a-select v-model="query.success" style="width: 100%;" placeholder="请选择返回状态" allowClear>
							<a-select-option :value="2">成功</a-select-option>
							<a-select-option :value="4">失败</a-select-option>
						</a-select>
					</div>
                    <div class="qinang-search-col-3">
                        <div  class="qinang-search-col-title" style="width: 100%;">
                            <a-button type="primary" icon="search" @click="apiOperationLogQueryList">查询</a-button>
                        </div>
                    </div>
				</div>
			</a-collapse-panel>
		</a-collapse>
		
		<div class="qinang-card">
			<div style="display: flex;justify-content: space-between;align-items: center;">
				<a-breadcrumb separator=">" style="padding: 12.5px 16px;" >
					<a-breadcrumb-item>
						操作日志列表
					</a-breadcrumb-item>
				</a-breadcrumb>
			</div>
			<a-table :columns="tableColumns" :data-source="tableData" row-key="operationLogId" :loading="tableLoading" :pagination="false">
                <span slot="index" slot-scope="text, record, index">
					{{(query.page - 1) * query.size + index + 1}}
				</span>
                <span slot="staffId" slot-scope="staffId">
					{{staffId.staffId}}
				</span>
                <span slot="enterpriseId" slot-scope="enterpriseId">
					{{enterpriseId.enterpriseId}}
				</span>
                <span slot="requestUrl" slot-scope="requestUrl">
					{{requestUrl.requestUrl}}
				</span>
                <span slot="module" slot-scope="module">
					{{module.module}}
				</span>
                <span slot="ipAddress" slot-scope="ipAddress">
					{{ipAddress.ipAddress}}
				</span>
                <span slot="method" slot-scope="method">
					{{method.method}}
				</span>
                <span slot="success" slot-scope="success">
					<span v-if="success.success == 2" style="color: green;">成功</span>
					<span v-if="success.success == 4" style="color: red;">失败</span>
				</span>
                <span slot="errorMsg" slot-scope="errorMsg">
					{{errorMsg.errorMsg || '-'}}
				</span>
                <span slot="duration" slot-scope="duration">
					{{duration.duration}} ms
				</span>
                <span slot="params" slot-scope="params">
					<a-button type="link" @click="showParams(params.params)">查看</a-button>
				</span>
                <span slot="result" slot-scope="result">
					<a-button type="link" @click="showResult(result.result)">查看</a-button>
				</span>
            </a-table>
			<a-pagination style="text-align: right;margin: 10px;" :current="query.page" :total="query.total" :default-page-size="query.size" show-size-changer show-quick-jumper size="small" :page-size-options="['10', '20', '50']"
				:show-total="total => `共 ${total} 条记录`" @change="pageChange" @showSizeChange="showSizeChange"/>
		</div>

		<!-- 参数详情弹窗 -->
		<a-modal title="提交参数详情" :visible="paramsVisible" @cancel="paramsVisible = false" width="600px">
			<pre style="white-space: pre-wrap; word-break: break-all; max-height: 400px; overflow-y: auto;">{{paramsDetail}}</pre>
		</a-modal>

		<!-- 返回结果弹窗 -->
		<a-modal title="返回参数详情" :visible="resultVisible" @cancel="resultVisible = false" width="600px">
			<pre style="white-space: pre-wrap; word-break: break-all; max-height: 400px; overflow-y: auto;">{{resultDetail}}</pre>
		</a-modal>
	</div>
</template>

<script>
	export default {
		name: 'operationLog',
		data() {
			return {
				selectFirstMenu: window.sessionStorage.getItem('selectFirstMenu'),
				selectSecondMenu: window.sessionStorage.getItem('selectSecondMenu'),
				// 搜索+表格-start
				query: {
					page: 1,
					size: 10,
					total: 0,
					staffId: '',
					module: '',
					ipAddress: '',
					requestUrl: '',
					success: ''
				},

				tableData: [],
				tableColumns: [
					{
						title: '序号',
						key: 'index',
						align: 'center',
						scopedSlots: {
							customRender: 'index'
						}
					},
					{
						title: '访问用户',
						dataIndex: 'staffId',
						key: 'staffId',
						align: 'center',
					
					},
					{
						title: '访问路径',
						dataIndex: 'requestUrl',
						key: 'requestUrl',
						align: 'center',
                        ellipsis: true,
					},
					{
						title: '访问模块',
						dataIndex: 'module',
						key: 'module',
						align: 'center',
                        ellipsis: true,
					},
					{
						title: '访问IP',
						dataIndex: 'ipAddress',
						key: 'ipAddress',
						align: 'center',
					},
					{
						title: '访问方法',
						dataIndex: 'method',
						key: 'method',
						align: 'center',
                        ellipsis: true,
					},
					
					
					{
						title: '提交参数',
						dataIndex: 'params',
						key: 'params',
						align: 'center',
                        ellipsis: true,
					},
					{
						title: '返回参数',
						dataIndex: 'result',
						key: 'result',
						align: 'center',
                        ellipsis: true,
					},
                    {
						title: '耗时',
						dataIndex: 'duration',
						key: 'duration',
						align: 'center',
					},
                    {
						title: '返回状态',
						key: 'success',
						align: 'center',
                        scopedSlots: {
                            customRender: 'success'
                        }
					},
					{
						title: '错误信息',
						dataIndex: 'errorMsg',
						key: 'errorMsg',
						align: 'center',
                        ellipsis: true,
					},
				],
				tableLoading: false,
				// 弹窗相关
				paramsVisible: false,
				paramsDetail: '',
				resultVisible: false,
				resultDetail: ''
				//搜索+表格-end
			};
		},
		methods: {
			async apiOperationLogQueryList() {
				this.tableLoading = true
				let params = {
					page: this.query.page,
					size: this.query.size,
					staffId: this.query.staffId,
					module: this.query.module,
					ipAddress: this.query.ipAddress,
					requestUrl: this.query.requestUrl,
					success: this.query.success
				}
				const {
					data: res
				} = await this.$http.post(this.navigation.apiOperationLogQueryList, params);
				if (res.code == 200) {
					this.tableData = res.data.list
					this.query.total = res.data.pages.total
				} else {
					this.$message.error(res.msg)
				}
				this.tableLoading = false
			},
			pageChange(page, pageSize) {
				this.query.page = page
				this.apiOperationLogQueryList()
			},
			showSizeChange(current, size) {
				this.query.size = size
				this.query.page = 1
				this.apiOperationLogQueryList()
			},
			showParams(params) {
				try {
					this.paramsDetail = typeof params === 'string' ? params : JSON.stringify(params, null, 2)
				} catch (e) {
					this.paramsDetail = params ? String(params) : '无数据'
				}
				this.paramsVisible = true
			},
			showResult(result) {
				try {
					this.resultDetail = typeof result === 'string' ? result : JSON.stringify(result, null, 2)
				} catch (e) {
					this.resultDetail = result ? String(result) : '无数据'
				}
				this.resultVisible = true
			}
		},
		created() {
			this.apiOperationLogQueryList()
		}
	};
</script>

<style scoped>
</style>
